import CheckoutCartItem, {
  CheckoutCartItemComponent,
} from './CheckoutCartItem';

export { CheckoutCartItemComponent };
export default CheckoutCartItem;
